var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d-container',{staticClass:"h-100 p-0",attrs:{"fluid":"","id":"app"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }